import { secureFetch } from "./authService";
import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from "./constants";

export function getUsers(query) {
	let url = API_BASE_URL + '/users?';

	if (query) {
		const {page = 0, filters, limit = PAGINATION_DEFAULT_LIMIT, companyId, sorting} = query;

		if (limit) {
			url = url + `&limit=${limit}`;
		}

		if (page || page === 0) {
			url = url + `&page=${page}`;
		}

		if (companyId) {
			url = url + `&companyId=${companyId}`;
		}

		if (filters && filters.length) {
			filters.forEach(filter => {
				if (filter.value) {
					url = url + `&${filter.name}=${filter.value}`;
				}
			});
		}

		if (sorting) {
			url = url + `&sortField=${sorting.id}&sort=${sorting.desc ? 'ASC' : 'DESC'}`;
		}

	}
	return secureFetch(url, {
		method: 'GET'
	});
}

export function addUser(user) {
	return secureFetch(API_BASE_URL + '/users', {
		method: 'POST',
		body: JSON.stringify(user)
	});
}

export function updateUser(user) {
	return secureFetch(API_BASE_URL + '/users/' + user.id, {
		method: 'PUT',
		body: JSON.stringify(user)
	});
}

export function delUser(userId) {
	return secureFetch(API_BASE_URL + '/users/' + userId, {
		method: 'DELETE'
	});
}

export function uploadNewUsers(data) {
	return secureFetch(API_UPLOAD_URL + '/users/upload', {
		method: 'POST',
		body: data
		//body: JSON.stringify(data)
	}, {});
}

export function uploadNewOperatorUsers(data) {
	return secureFetch(API_UPLOAD_URL + '/users/upload/operator', {
		method: 'POST',
		body: data
	}, {});
}



// WEBPACK FOOTER //
// ./src/helpers/userService.js